export default "__VITE_ASSET__D9o_uecE__"